<div #popover="ngbPopover"
     [ngbPopover]="popContent"
     [popoverClass]="'bg-danger column-validation'"
     [placement]="'bottom'"
     [autoClose]="false"
     [animation]="false"
     container="body"
     triggers="manual">
  <div class="input-group input-group-sm has-validation"
       ngbTooltip="columnFilterTooltipContent"
       placement="top"
       container="body">
    <input class="form-control"
           [class.is-invalid]="isInvalid"
           [class.is-invalid]="column.value?.length > 0 && isInvalid === true"
           [class.is-valid]="column.value?.length > 0 && isInvalid === false"
           [(ngModel)]="column.value"
           (ngModelChange)="valueChangedWithDebounceTime()"
           [ngbTooltip]="column.operatorsTooltip"
           triggers="focusin:keydown"
           placement="bottom"
           [disableTooltip]="!column.operatorsTooltip"
           container="body">
    <button *ngIf="column?.value?.length > 0"
            class="btn btn-light border-dark"
            type="button"
            (click)="clearColumnFilterValue()">
      <i class="fa-light fa-xmark"></i>
    </button>
    <div class="invalid-tooltip d-none"></div>
  </div>
</div>

<ng-template #popContent>
  <div class="text-light p-2">
    <i class="fa-light fa-circle-exclamation me-1"></i>{{errorMessage}}
  </div>
</ng-template>

<ng-template #columnFilterTooltipContent>
  <div *ngIf="column.id === almaSourceNameColumnId" style="color: yellow;">
    <i class="fa-light fa-warning me-1"></i> 
    {{almaSourceFilterColumnTooltip}} 
  </div>
  <div *ngIf="column.id !== almaSourceNameColumnId">
    {{columnFilterTooltip}}
  </div>
</ng-template>
